import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LuCheck, LuChevronRight, LuX } from "react-icons/lu";
import axios from "../../axios";
import { FIRST_STEPS_HIDDEN, isNewAccount, markSeen, openCabinetTour, TOUR_STUDENT, wasSeen } from "../../helpers/tour/tour";
import * as styled from "./FirstSteps.styled";

// Чекліст «Перші кроки» на головній нового учня (акаунт до 30 днів). Що виконано — з бази (auth/first-steps),
// зникає, коли все зроблено або учень закрив його хрестиком. Пункту про бота немає, якщо бот уже підключено.
function FirstSteps({ data }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [facts, setFacts] = useState(null);
  const [bot, setBot] = useState(null);
  const show = isNewAccount(data) && !wasSeen(data, FIRST_STEPS_HIDDEN);

  useEffect(() => {
    if (!show) return;
    axios.get("auth/first-steps").then((res) => setFacts(res.data)).catch(() => {});
    axios.get("students/me/bot").then((res) => setBot(res.data)).catch(() => {});
  }, [show, data?._id]);

  if (!show || !facts) return null;

  const botUrl = !facts.telegram && bot?.enabled && !bot.linked ? bot.url : null;

  const items = [
    { done: wasSeen(data, TOUR_STUDENT), title: "Познайомся з кабінетом", text: "Тур на пів хвилини", onClick: openCabinetTour },
    botUrl && { done: false, title: "Підключи Telegram-бот", text: "Нагадування про уроки й баланс", onClick: () => window.open(botUrl, "_blank", "noopener") },
    { done: facts.firstLesson, title: "Пройди перший урок", text: "Час уроку — у розкладі", onClick: () => navigate("/student/schedule") },
    { done: facts.firstHomework, title: "Здай перше ДЗ", text: "+1 ⭐ за кожне здане", onClick: () => navigate("/student/homework") },
  ].filter(Boolean);
  const doneCount = items.filter((item) => item.done).length;
  if (doneCount === items.length) return null;

  return (
    <styled.Card data-tour="first-steps">
      <styled.Head>
        <div>
          <styled.Title>Перші кроки</styled.Title>
          <styled.Progress>
            {doneCount} з {items.length} виконано
          </styled.Progress>
        </div>
        <styled.Hide type="button" aria-label="Сховати перші кроки" onClick={() => markSeen(dispatch, FIRST_STEPS_HIDDEN)}>
          <LuX size={18} />
        </styled.Hide>
      </styled.Head>
      <styled.Bar>
        <span style={{ width: `${(doneCount / items.length) * 100}%` }} />
      </styled.Bar>
      <styled.List>
        {items.map(({ done, title, text, onClick }) => (
          <li key={title}>
            <styled.Item type="button" $done={done} disabled={done} onClick={onClick}>
              <styled.Check $done={done}>{done && <LuCheck size={16} />}</styled.Check>
              <styled.ItemText>
                <b>{title}</b>
                {!done && <small>{text}</small>}
              </styled.ItemText>
              {!done && <LuChevronRight size={18} className="arrow" />}
            </styled.Item>
          </li>
        ))}
      </styled.List>
    </styled.Card>
  );
}

export default FirstSteps;
